import { render, staticRenderFns } from "./CommentsForm.vue?vue&type=template&id=c8e64e4a&scoped=true"
import script from "./CommentsForm.vue?vue&type=script&lang=js"
export * from "./CommentsForm.vue?vue&type=script&lang=js"
import style0 from "./CommentsForm.vue?vue&type=style&index=0&id=c8e64e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e64e4a",
  null
  
)

export default component.exports